import { theme } from '@prose-ui';
import { withStyles } from 'legacyStyles';

import { Faq } from 'Blocks/Faq';

const StyledFaq = withStyles(Faq, {
  collapse: {
    borderBottom: 'none',
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(255,255,255,0.5)',
    },
  },
});

const FAQBlock = () => (
  <StyledFaq
    backgroundColor={theme.colors.neutral[500]}
    keepLineBreaks
    questions={[
      {
        question: 'How much does it cost to subscribe?',
        answer: `Subscribing to your custom product is completely free — and you’ll unlock perks like 15% off every order, free shipping, special offers, and always improving products.`,
      },
      {
        question: 'Can I subscribe to haircare and skincare?',
        answer:
          'Yes! By subscribing to haircare and skincare you’ll enjoy the same subscriber-exclusive perks across both of your subscriptions, including 15% off + free shipping on every future order.',
      },
      {
        question: 'How can I modify my subscription order?',
        answer: `Our subscription service is fully customizable. You can control which products are included in upcoming orders, change how frequently any one product is delivered, and skip deliveries for any product in your order. To make these changes, visit Subscriptions in your account.`,
      },
      {
        question: 'How do I snooze or cancel my subscription?',
        answer: `To manage your subscription, head to Subscriptions in your account. If you’re not quite ready for your next Prose order, you can snooze your order for 1–4 weeks at a time. 
      
      If you need to cancel, you’ll find the "Cancel my subscription" link under your order summary. You can still purchase your custom Prose products without subscribing, but you will no longer have access to the perks that come with subscribing. Any progress made in your complimentary product tracker will be lost.`,
      },
    ]}
    title="Membership FAQs"
  />
);

export default FAQBlock;
